<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
      <i class="el-icon-s-fold" ></i>
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item >系统服务</el-breadcrumb-item>
        <el-breadcrumb-item >用户手册</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">用户操作指导</div>
          </div>
        </div>
        <div style="padding: 0px 10px;">
          <el-collapse v-model="activeName" accordion>
            <div v-for="(item,index) in data">
              <!-- <icon class="el-icon-thumb" style="color: #fff;height: 50px;line-height: 50px;"></icon> -->
              <el-collapse-item :title="item.title" :name="item.index">
                <div  v-for="(subItem,subIndex) in item.brief">
                  {{subIndex+1}}、{{subItem}}
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        activeName:'',
        data:[{'title':'新增分组','content':'','brief':['点击菜单栏中的“内容管理”','点击“分组管理”','点击“添加分组”']},
              {'title':'修改分组','content':'','brief':['点击菜单栏中的“内容管理”','点击“分组管理”','点击“修改”']},
              {'title':'删除分组','content':'','brief':['点击菜单栏中的“内容管理”','点击“分组管理”','点击“删除”']},
              {'title':'查看分组','content':'','brief':['点击菜单栏中的“内容管理”','点击“分组管理”']},
              {'title':'新增账号','content':'','brief':['点击菜单栏中的“内容管理”','点击“账号管理”','点击“新增账号”']},
              {'title':'修改账号','content':'','brief':['点击菜单栏中的“内容管理”','点击“账号管理”','点击“修改绑定”']},
              {'title':'注销账号','content':'','brief':['点击菜单栏中的“内容管理”','点击“账号管理”','点击“删除”']},
              {'title':'查看账号','content':'','brief':['点击菜单栏中的“内容管理”','点击“账号管理”']},
              {'title':'新增识别码规则','content':'','brief':['点击菜单栏中的“内容管理','点击“识别码管理”','点击“新增设备识别规则”','点击“新增耗材识别规则”']},
              {'title':'删除识别码规则','content':'','brief':['点击菜单栏中的“内容管理','点击“识别码管理”','点击“删除”']},
              {'title':'查看识别码规则','content':'','brief':['点击菜单栏中的“内容管理”','点击“识别码管理”']},
              {'title':'设备注册','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”','点击“设备注册”']},
              {'title':'设备修改','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”','点击“修改信息”']},
              {'title':'设备注销','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”','点击设备UDI','点击“注销”']},
              {'title':'查看设备','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”']},
              {'title':'查看设备详情','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”','点击“设备UDI”']},
              {'title':'查看使用单位信息','content':'','brief':['点击菜单栏中的“内容管理”','点击“设备管理”','点击“使用单位”']},
              {'title':'耗材入库','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','点击“耗材库存记录','点击“耗材出库”']},
              {'title':'耗材出库','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','点击“公司库存记录','点击“耗材出库”']},
              {'title':'耗材删除','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','找到对应耗材','点击“删除']},
              {'title':'查看耗材使用列表','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','点击“耗材使用记录”']},
              {'title':'查看使用单位剩余耗材','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','点击“使用单位耗材剩余”']},
              {'title':'查看公司耗材库存','content':'','brief':['点击菜单栏中的“内容管理”','点击“耗材管理”','点击“耗材库存记录”']},
              {'title':'新增知识库','content':'','brief':['点击菜单栏中的“内容管理”','点击“知识库管理”','点击“新增知识库”']},
              {'title':'删除知识库','content':'','brief':['点击菜单栏中的“内容管理”','点击“知识库管理”','点击“删除”']},
              {'title':'新增访问控制','content':'','brief':['点击菜单栏中的“内容管理”','点击“访问控制管理”','点击“新增IP访问控制”','点击“新增时间访问控制”']},
              {'title':'删除访问控制','content':'','brief':['点击菜单栏中的“内容管理”','点击“访问控制管理”','点击“删除”']},
              {'title':'设备监控','content':'','brief':['点击菜单栏中的“监控告警”','点击“设备监控”']},
              {'title':'处理设备异常','content':'','brief':['点击菜单栏中的“监控告警”','点击“设备监控”','点击“立即处理”或“继续处理”']},
              {'title':'新增设备处理过程','content':'','brief':['点击菜单栏中的“监控告警”','点击“设备监控”','点击“立即处理”或“继续处理”','点击“添加处理信息”']},
              {'title':'耗材告警','content':'','brief':['点击菜单栏中的“监控告警”','点击“耗材告警”','点击“耗材剩余”']},
              {'title':'个人信息','content':'','brief':['点击菜单栏中的“个人中心”']},
              {'title':'修改密码','content':'','brief':['点击菜单栏中的“个人中心”','点击“修改密码”']},
              {'title':'退出登录','content':'','brief':['点击菜单栏中的“个人中心”','点击“退出”']},
              {'title':'用户手册','content':'','brief':['点击菜单栏中的“系统服务”','点击“用户手册”']},
              {'title':'日志','content':'','brief':['点击菜单栏中的“系统服务”','点击“系统日志”']},
              {'title':'建议反馈','content':'','brief':['点击菜单栏中的“系统服务”','点击“建议反馈”']},
              {'title':'消息提醒','content':'','brief':['点击菜单栏中的“系统服务”','点击“消息提醒”']},
              {'title':'关于系统','content':'','brief':['点击菜单栏中的“系统服务”','点击“关于系统”']},
              {'title':'数据分析','content':'','brief':['点击菜单栏中的“数据分析”']},
              {'title':'大屏','content':'','brief':['点击导航栏上的“大屏”']}
              ],
      }
    }
  }
</script>


<style lang="scss" scoped>

  .container{
    height: 100%;
    margin-top: $header-height;

    .content{
      border: 2px solid #1A3F81;
      border-radius: 12px;

      .header-common{
        width: 100%;
        height: 45px;
        border-radius: 12px 12px 0 0 ;
        background: linear-gradient(-90deg, #001940, #1564BE);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        // margin: 15px 0px 0px 6px;

        .header-common-left{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
          margin-left: 21px;
          .title{
            font-size: 20px;
            font-weight: bold;
            color: #FEFEFE;
          }
        }

        .header-common-right{

          .right-button{
            width: 140px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,255,96,0.84);
            border-radius: 20px;
            background-color: #208D7F;
            font-size: 14px;
            font-weight: 400;
            color: #00FFB4;
            margin-right: 20px;
          }

          .all-button{
            width: 89px;
            height: 36px;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
            margin-right: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/system/manual.vue